<template lang="pug">
v-dialog(v-model='dialogPricingOpen', width='600', content-class='dialog-pricing')
  v-btn.ma-0(flat, small, color='primary', slot='activator')  Tarieven & info

  v-card.pa-4
    v-card-title
      h2 {{ title }}

    v-card-text
      table.v-datatable.v-table.theme--light
        thead
          tr
            td.pa-3: b {{ header[0] }}
            td.pa-3: b {{ header[1] }}
        tbody
          tr(v-for='item in items')
            td.pa-3 {{ item.name }}
            td.pa-3 {{ item.value }}

      .pl-3.mt-4
        //- p De gemaakte kosten kun je terug zien onder Statistieken in het menu. Deze kosten worden 1x per maand gefactureerd.
        p Deze kosten worden 1x per maand gefactureerd.

    v-card-actions
      v-spacer
      v-btn(color='primary', @click='dialogPricingOpen = false') Sluiten
</template>

<script>
export default {
  props: {
    title: String,
    items: Array,
    header: Array
  },

  data () {
    return {
      dialogPricingOpen: false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
